export default __webpack_public_path__ + "static/media/eytan-elbaz@2x.584163c5.png";